import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from './security/security.service';
import { AuthService } from './data-services/auth.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';

// Required for MSAL
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';

// Required for RJXS
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { RouterModule } from '@angular/router'; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [ NavMenuComponent, RouterModule ]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'AccessDX LabTek21';
  loginDisplay = false;
  tokenExpiration: string = '';
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private securityService: SecurityService,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router
  ) { }

  // On initialization of the page, display the page elements based on the user state
  async ngOnInit(): Promise<any> {
    await this.authService.instance.initialize();

    // in app.component.ts       
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS
            || msg.eventType === EventType.SSO_SILENT_SUCCESS)
    ).subscribe((result: EventMessage) => {
        console.log("LOGIN_SUCCESS", result);
        const payload = result.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);
        if (window.location.pathname.toLowerCase() == "/auth/callback") {
          console.log("redirecting");
          this.router.navigate(['/']).then(() => window.location.reload());
        }
      });

    //this.authService.instance.handleRedirectPromise().then((res) => {
    //  console.log("handleRedirectPromise", res);
    //  if (res != null && res.account != null) {
    //    this.authService.instance.setActiveAccount(res.account);
    //    if (window.location.pathname.toLowerCase() == "/auth/callback") {
    //      console.log("redirecting");
    //      this.router.navigate(['/']).then(() => window.location.reload());
    //    }
    //  }

    //});

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });

    // Used for storing and displaying token expiration
    this.msalBroadcastService.msalSubject$.pipe(filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS)).subscribe(msg => {
      this.tokenExpiration = (msg.payload as any).expiresOn;
      localStorage.setItem('tokenExpiration', this.tokenExpiration);
    });
  }

  // If the user is logged in, present the user with a "logged in" experience
  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  // Log the user in and redirect them if MSAL provides a redirect URI otherwise go to the default URI
  login() {
    if (this.msalGuardConfig.authRequest) {
      console.log('auth request', this.msalGuardConfig.authRequest);
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      console.log('login request', this.msalGuardConfig.authRequest);
      this.authService.loginRedirect();
    }
  }

  // Log the user out
  logout() {
    const account = this.authService.instance.getAllAccounts()[0];

    this.authService.logoutRedirect({ account: account });
    this.securityService.logout();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
